module.exports = __webpack_public_path__ + "static/img/mysql.d4361214.png";